import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './App.css';

// Auth Components
import ProtectedRoute from './components/Auth/ProtectedRoute';
import IdleSessionHandler from './components/IdleSessionHandler/IdleSessionHandler';
import LoginPage from './pages/LoginPage';

// Pages
import DashboardPage from './pages/DashboardPage';
import SystemUsersPage from './pages/SystemUsersPage';
import ConsumersPage from './pages/ConsumersPage';
import DebtsPage from './pages/DebtsPage';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <IdleSessionHandler />
        <div className="App">
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Protected Routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/system-users" 
              element={
                <ProtectedRoute>
                  <SystemUsersPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/consumers" 
              element={
                <ProtectedRoute>
                  <ConsumersPage />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/debts" 
              element={
                <ProtectedRoute>
                  <DebtsPage />
                </ProtectedRoute>
              } 
            />
            
            {/* Redirect root to dashboard */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Catch all - redirect to dashboard */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </Provider>
  );
};

export default App;

